import { basicEnum } from "./base";

export const UserTypeEnum = basicEnum([
    {
        label: "DEV",
        value: "dev",
    },
    {
        label: "SUPER",
        value: "super",
    },
    {
        label: "ADMIN",
        value: "admin",
    },
    {
        label: "AUDITOR",
        value: "auditor",
    },
    {
        label: "ASSOCIATE",
        value: "associate",
    },
    {
        label: "CUSTOMER",
        value: "customer",
    },
    {
        label: "RESELLER",
        value: "reseller",
    },
]);

export namespace UserTypeEnum {
    export type Labels = (typeof UserTypeEnum)["labels"][number];
    export type Values = (typeof UserTypeEnum)["values"][number];
}
